export { default as SpinnerLoading } from './spinner-loading';
